export const langImportFile = {
  fr: {
    import1: 'Le fichier ',
    import2: ' est incomplet et ne peut pas être utilisé.',
    import3: 'Sur ',
    import4: 'points de mesure,',
    importTime: " n'ont pas d'info relative à l'heure",
    importLat: " n'ont pas d'info relative à la latitude",
    importLng: " n'ont pas d'info relative à la longitude",
    importSpeed: " n'ont pas d'info relative à la vitesse",
  },
  eng: {
    import1: 'File ',
    import2: ' is incomplete and cannot be used.',
    import3: 'Over ',
    import4: 'measurement points,',
    importTime: ' have no time-related information',
    importLat: ' have no latitude information',
    importLng: ' have no longitude information',
    importSpeed: ' have no speed information',
  },
}
